import axios, { AxiosInstance, InternalAxiosRequestConfig } from 'axios';
import {
  compose,
  withRetries,
  withE2ERequestStubbing,
} from '@lifeomic/phc-web-toolkit/src/hooks/useService';
import { accountSelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/account';
import { authSelectors } from '@lifeomic/phc-web-toolkit/src/redux/modules/auth';

// @ts-expect-error This directive was added as part of a bulk-change to enable noImplicitAny.
import store from '../redux/store';

interface UseOneQueryClientOptions {
  urlPrefix?: string;
}

// @ts-expect-error This directive was added as part of a bulk-change to enable strictNullChecks.
let client: AxiosInstance = null;

/**
 * @param option hook options.
 * @param option.urlPrefix prefix to request URLs
 * @returns client with auth/account/config context
 */
export default function getOneQueryClient({
  urlPrefix,
}: UseOneQueryClientOptions): AxiosInstance {
  if (client) {
    return client;
  }

  client = compose<AxiosInstance>(
    withE2ERequestStubbing,
    withRetries(),
  )(axios.create());

  client.interceptors.request.use((request: InternalAxiosRequestConfig) => {
    const state = store.getState();
    // Add account header.
    const account = accountSelectors.selectActiveAccountId(state);
    if (account) {
      request.headers['LifeOmic-Account'] = account;
    }
    // Add auth token.
    const authToken = authSelectors.selectAccessToken(state);
    if (authToken) {
      request.headers['Authorization'] = `Bearer ${authToken}`;
    }

    request.url = `${urlPrefix ?? ''}${request.url}`;

    request.paramsSerializer = {
      // This serializes query params passed as arrays to be a format typically
      // supported in the platform.
      // Example: { _tag: [abc, xyz, lmn] } => _tag=abc&_tag=xyz&_tag=lmn
      // In this case "_tag" is used but it could be any key.
      indexes: null,
    };

    return request;
  });

  return client;
}
